import { formatTime, getPrintableTime } from '../../../../lib/datetime'

export const getOrderActionDate = (actionAt) => {
  if (!actionAt) {
    return null
  }
  return getPrintableTime(actionAt).split(', ')[0]
}

export const getOrderActionTime = (actionAt) => {
  if (!actionAt) {
    return null
  }
  return getPrintableTime(actionAt).split(', ')[1]
}

/**
 * Formats preferred date like the legacy Order Slot column: "14 Aug 2026"
 * (no ordinal). Accepts YYYY-MM-DD or datetime strings.
 */
export const formatOrderSlotDate = (preferredDate) => {
  if (!preferredDate) {
    return null
  }
  const dateOnly = String(preferredDate).split('T')[0].split(' ')[0]
  return getOrderActionDate(dateOnly)
}

/**
 * Formats slot times like the legacy Order Slot column: "6:00 PM - 8:00 PM"
 */
export const formatOrderSlotTime = (slotStartTime, slotEndTime) => {
  if (!slotStartTime && !slotEndTime) {
    return null
  }
  if (slotStartTime && slotEndTime) {
    return `${formatTime(slotStartTime)} - ${formatTime(slotEndTime)}`
  }
  return formatTime(slotStartTime || slotEndTime) || null
}
